// Get Serial Statistics Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {SerialStatistics} from '../models/inventory.model';

export class GetSerialStatisticsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (): Promise<SerialStatistics> {
    try {
      const statistics = await this.inventoryRepository.getSerialStatistics();
      return statistics;
    } catch (error) {
      throw error;
    }
  }
}
